<div class="space-y-4 p-4">
  <div>
    <label class="text-sm text-gray-700 mb-1 block">Prénom</label>
    <input
      type="text"
      class="input w-full !border-gray-300"
      placeholder="Prénom"
      [(ngModel)]="form.firstName"
    />
  </div>
  <div>
    <label class="text-sm text-gray-700 mb-1 block">Nom</label>
    <input
      type="text"
      class="input w-full !border-gray-300"
      placeholder="Nom"
      [(ngModel)]="form.lastName"
    />
  </div>
  <div>
    <label class="text-sm text-gray-700 mb-1 block">Lien de parenté</label>
    <input
      type="text"
      class="input w-full !border-gray-300"
      placeholder="Ex: Père, Mère, Frère..."
      [(ngModel)]="form.relationship"
    />
  </div>
  <div class="flex justify-end gap-2 pt-2">
    <button class="btn btn-ghost btn-sm" (click)="cancel()">Annuler</button>
    <button class="btn btn-primary btn-sm" [disabled]="!isValid()" (click)="confirm()">Ajouter</button>
  </div>
</div>
